export default "__VITE_ASSET__BzpWrmds__"